import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import { ValidationService } from 'src/app/core/services/validation.service';
import { isValiddateNumber } from 'src/app/core/directives/country-flag-phone/country-flag-phone.directive';

@Component({
  selector: 'app-fan-landing-page',
  templateUrl: './fan-landing-page.component.html',
  styleUrls: ['./fan-landing-page.component.scss']
})
export class FanLandingPageComponent implements OnInit {
  signUpForm: FormGroup;
  phone_number: any;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  constructor( private commanSubscribeService: CommanSubscribeService,
    private router: Router, private toastr: ToastrService, private _formBuilder: FormBuilder) { }

  ngOnInit() {
    this.userInfo = this.commanSubscribeService.userInfo;
    if (this.userInfo && Object.keys(this.userInfo)?.length != 0) {
      if (this.userInfo.account_setup_status == 0 && !localStorage.accountSetup) {
        this.toastr.error("Please setup your account.");
        this.router.navigateByUrl('account/business-setup');
      } else {
        this.router.navigateByUrl('dashboard');
      }
    }
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.buildForm();
  }

  buildForm() {
    this.signUpForm = this._formBuilder.group({
      email: ['', [Validators.required, ValidationService.emailValidator]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone_number: ['', [Validators.required, isValiddateNumber.isvalidNumber(false)]]
    });
  }

  goToSignUp(){
    if(this.signUpForm.valid){
    let inputData = this.signUpForm.getRawValue();
    this.commanSubscribeService.sendSignUpInfo(inputData);
    this.router.navigateByUrl('/signup');
    }
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
  }
}
